const sectionMarkqueueRowsCss = `
[data-type='section-markqueue-rows'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 16px;
  margin-bottom: 30px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h1,
[data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h2,
[data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows {
  overflow: hidden;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  animation: markqueue-rows-animation 15s linear infinite;
  animation-play-state: running;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:hover {
  animation-play-state: paused;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) {
  margin-left: -20px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item .wrap-img {
  flex-shrink: 0;
  height: 200px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item .wrap-img img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* Odd rows image widths */
[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n + 1) {
  width: 150px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n + 2) {
  width: 200px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n) {
  width: 250px;
}

/* Even rows image widths */
[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n + 1) {
  width: 250px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n + 2) {
  width: 150px;
}

[data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n) {
  width: 200px;
}

@keyframes markqueue-rows-animation {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

@container (max-width: 768px) {
  [data-type='section-markqueue-rows'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h1,
  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h2,
  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .title-markqueue h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item {
    margin-bottom: 10px;
    gap: 10px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item .wrap-img {
    height: 150px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n + 1) {
    width: 100px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n + 2) {
    width: 150px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n + 1) .wrap-img:nth-child(3n) {
    width: 200px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n + 1) {
    width: 200px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n + 2) {
    width: 100px;
  }

  [data-type='section-markqueue-rows'] [data-attribute='card-container'] .list-rows .wrap-item:nth-child(2n) .wrap-img:nth-child(3n) {
    width: 150px;
  }
}
`;
export default sectionMarkqueueRowsCss;
